export const deepPurple50 = "#ebebfb";
export const deepPurple100 = "#e3e1fa";
export const deepPurple200 = "#c8c3f5";
export const deepPurple300 = "#ada6f0";
export const deepPurple400 = "#9288eb";
export const deepPurple500 = "#776be6";
export const deepPurple600 = "#655ee0";
export const deepPurple700 = "#5452da";
export const deepPurple800 = "#4345d4";
export const deepPurple900 = "#3239cf";
export const deepPurple1000 = "#1717ba";
export const deepPurpleA100 = "#d6c0fa";
export const deepPurpleA200 = "#b2a0f2";
export const deepPurpleA400 = "#3b35d9";
export const deepPurpleA500 = "#0908c6";
export const deepPurpleA1000 = "#292550";
